import { useTranslate } from "@tolgee/react";
import CreatorCard from "../commonElements/creatorCard";
import CreatorTitle from "../commonElements/creatorTitle";
import { ALL, PLATFORM_LIST_WITH_ALL } from "../../../../config/constants";
import { useDispatch, useSelector } from "react-redux";
import { setPostDataAttribute } from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { useEffect, useState } from "react";

export const TitleCard = ({ prefix }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const [oldPrefix, setOldPrefix] = useState(null);

  const title = useSelector(
    (state: any) => state.lomavisCreator.postData[ALL][`${prefix}_title`]
  );
  const subtitle = useSelector(
    (state: any) => state.lomavisCreator.postData[ALL][`${prefix}_subtitle`]
  );
  // on prefix change set old prefix to empty string
  useEffect(() => {
    if (oldPrefix !== prefix) {
      PLATFORM_LIST_WITH_ALL.forEach((platform) => {
        dispatch(
          setPostDataAttribute({
            platform: platform,
            attribute: `${oldPrefix}_title`,
            value: "",
          })
        );
        dispatch(
          setPostDataAttribute({
            platform: platform,
            attribute: `${oldPrefix}_subtitle`,
            value: "",
          })
        );
      });
      setOldPrefix(prefix);
    }
    if (oldPrefix === null) {
      setOldPrefix(prefix);
    }
  }, [prefix]);

  return (
    <CreatorCard>
      <CreatorTitle title="typeAdditionalOptionstitle" />
      <label htmlFor={`${prefix}_title`}>
        {t("lomavisCreator.typeAdditionalOptions.Title")}
      </label>
      <input
        id={`${prefix}_title`}
        type="text"
        className="form-control form-control-sm"
        maxLength={50}
        value={title || ""}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: `${prefix}_title`,
                value: e.target.value,
              })
            );
          });
        }}
      />
      <span className="text-muted">
        {t("lomavisCreator.typeAdditionalOptions.titleHelpText")}
      </span>

      <div className="mt-2" />
      <label htmlFor={`${prefix}_subtitle`}>
        {t("lomavisCreator.typeAdditionalOptions.subtitle")}
      </label>
      <input
        id={`${prefix}_subtitle`}
        type="text"
        className="form-control form-control-sm"
        maxLength={50}
        value={subtitle || ""}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: `${prefix}_subtitle`,
                value: e.target.value,
              })
            );
          });
        }}
      />
      <span className="text-muted">
        {t("lomavisCreator.additionalOptions.subtitleHelpText")}
      </span>
    </CreatorCard>
  );
};
